// source: sentiment-analyzer.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global =
    (typeof globalThis !== 'undefined' && globalThis) ||
    (typeof window !== 'undefined' && window) ||
    (typeof global !== 'undefined' && global) ||
    (typeof self !== 'undefined' && self) ||
    (function () { return this; }).call(null) ||
    Function('return this')();

var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js');
goog.object.extend(proto, google_protobuf_timestamp_pb);
goog.exportSymbol('proto.sentimentanalyzer.Bias', null, global);
goog.exportSymbol('proto.sentimentanalyzer.BrokerSymbolInfo', null, global);
goog.exportSymbol('proto.sentimentanalyzer.CurrencyStrength', null, global);
goog.exportSymbol('proto.sentimentanalyzer.DateWiseData', null, global);
goog.exportSymbol('proto.sentimentanalyzer.GetBrokersSymbolSentimentReply', null, global);
goog.exportSymbol('proto.sentimentanalyzer.GetBrokersSymbolSentimentReq', null, global);
goog.exportSymbol('proto.sentimentanalyzer.GetSymbolsReply', null, global);
goog.exportSymbol('proto.sentimentanalyzer.GetSymbolsReq', null, global);
goog.exportSymbol('proto.sentimentanalyzer.GetSymbolsSentimentReply', null, global);
goog.exportSymbol('proto.sentimentanalyzer.GetSymbolsSentimentReq', null, global);
goog.exportSymbol('proto.sentimentanalyzer.HotFxPair', null, global);
goog.exportSymbol('proto.sentimentanalyzer.SENTIMENT_TREND', null, global);
goog.exportSymbol('proto.sentimentanalyzer.SYMBOLS_FILTER', null, global);
goog.exportSymbol('proto.sentimentanalyzer.SentimentOverviewReply', null, global);
goog.exportSymbol('proto.sentimentanalyzer.SentimentOverviewReq', null, global);
goog.exportSymbol('proto.sentimentanalyzer.SymbolBias', null, global);
goog.exportSymbol('proto.sentimentanalyzer.SymbolInfo', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.sentimentanalyzer.GetSymbolsReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.sentimentanalyzer.GetSymbolsReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.sentimentanalyzer.GetSymbolsReq.displayName = 'proto.sentimentanalyzer.GetSymbolsReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.sentimentanalyzer.GetSymbolsReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.sentimentanalyzer.GetSymbolsReply.repeatedFields_, null);
};
goog.inherits(proto.sentimentanalyzer.GetSymbolsReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.sentimentanalyzer.GetSymbolsReply.displayName = 'proto.sentimentanalyzer.GetSymbolsReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.sentimentanalyzer.SentimentOverviewReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.sentimentanalyzer.SentimentOverviewReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.sentimentanalyzer.SentimentOverviewReq.displayName = 'proto.sentimentanalyzer.SentimentOverviewReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.sentimentanalyzer.HotFxPair = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.sentimentanalyzer.HotFxPair, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.sentimentanalyzer.HotFxPair.displayName = 'proto.sentimentanalyzer.HotFxPair';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.sentimentanalyzer.Bias = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.sentimentanalyzer.Bias.repeatedFields_, null);
};
goog.inherits(proto.sentimentanalyzer.Bias, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.sentimentanalyzer.Bias.displayName = 'proto.sentimentanalyzer.Bias';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.sentimentanalyzer.DateWiseData = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.sentimentanalyzer.DateWiseData, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.sentimentanalyzer.DateWiseData.displayName = 'proto.sentimentanalyzer.DateWiseData';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.sentimentanalyzer.SymbolBias = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.sentimentanalyzer.SymbolBias.repeatedFields_, null);
};
goog.inherits(proto.sentimentanalyzer.SymbolBias, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.sentimentanalyzer.SymbolBias.displayName = 'proto.sentimentanalyzer.SymbolBias';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.sentimentanalyzer.CurrencyStrength = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.sentimentanalyzer.CurrencyStrength, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.sentimentanalyzer.CurrencyStrength.displayName = 'proto.sentimentanalyzer.CurrencyStrength';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.sentimentanalyzer.SentimentOverviewReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.sentimentanalyzer.SentimentOverviewReply.repeatedFields_, null);
};
goog.inherits(proto.sentimentanalyzer.SentimentOverviewReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.sentimentanalyzer.SentimentOverviewReply.displayName = 'proto.sentimentanalyzer.SentimentOverviewReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.sentimentanalyzer.GetSymbolsSentimentReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.sentimentanalyzer.GetSymbolsSentimentReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.sentimentanalyzer.GetSymbolsSentimentReq.displayName = 'proto.sentimentanalyzer.GetSymbolsSentimentReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.sentimentanalyzer.SymbolInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.sentimentanalyzer.SymbolInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.sentimentanalyzer.SymbolInfo.displayName = 'proto.sentimentanalyzer.SymbolInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.sentimentanalyzer.GetSymbolsSentimentReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.sentimentanalyzer.GetSymbolsSentimentReply.repeatedFields_, null);
};
goog.inherits(proto.sentimentanalyzer.GetSymbolsSentimentReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.sentimentanalyzer.GetSymbolsSentimentReply.displayName = 'proto.sentimentanalyzer.GetSymbolsSentimentReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.sentimentanalyzer.GetBrokersSymbolSentimentReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.sentimentanalyzer.GetBrokersSymbolSentimentReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.sentimentanalyzer.GetBrokersSymbolSentimentReq.displayName = 'proto.sentimentanalyzer.GetBrokersSymbolSentimentReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.sentimentanalyzer.BrokerSymbolInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.sentimentanalyzer.BrokerSymbolInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.sentimentanalyzer.BrokerSymbolInfo.displayName = 'proto.sentimentanalyzer.BrokerSymbolInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.sentimentanalyzer.GetBrokersSymbolSentimentReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.sentimentanalyzer.GetBrokersSymbolSentimentReply.repeatedFields_, null);
};
goog.inherits(proto.sentimentanalyzer.GetBrokersSymbolSentimentReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.sentimentanalyzer.GetBrokersSymbolSentimentReply.displayName = 'proto.sentimentanalyzer.GetBrokersSymbolSentimentReply';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.sentimentanalyzer.GetSymbolsReq.prototype.toObject = function(opt_includeInstance) {
  return proto.sentimentanalyzer.GetSymbolsReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.sentimentanalyzer.GetSymbolsReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.sentimentanalyzer.GetSymbolsReq.toObject = function(includeInstance, msg) {
  var f, obj = {
userId: jspb.Message.getFieldWithDefault(msg, 1, ""),
filter: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.sentimentanalyzer.GetSymbolsReq}
 */
proto.sentimentanalyzer.GetSymbolsReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.sentimentanalyzer.GetSymbolsReq;
  return proto.sentimentanalyzer.GetSymbolsReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.sentimentanalyzer.GetSymbolsReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.sentimentanalyzer.GetSymbolsReq}
 */
proto.sentimentanalyzer.GetSymbolsReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    case 2:
      var value = /** @type {!proto.sentimentanalyzer.SYMBOLS_FILTER} */ (reader.readEnum());
      msg.setFilter(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.sentimentanalyzer.GetSymbolsReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.sentimentanalyzer.GetSymbolsReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.sentimentanalyzer.GetSymbolsReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.sentimentanalyzer.GetSymbolsReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getFilter();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
};


/**
 * optional string user_id = 1;
 * @return {string}
 */
proto.sentimentanalyzer.GetSymbolsReq.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.sentimentanalyzer.GetSymbolsReq} returns this
 */
proto.sentimentanalyzer.GetSymbolsReq.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional SYMBOLS_FILTER filter = 2;
 * @return {!proto.sentimentanalyzer.SYMBOLS_FILTER}
 */
proto.sentimentanalyzer.GetSymbolsReq.prototype.getFilter = function() {
  return /** @type {!proto.sentimentanalyzer.SYMBOLS_FILTER} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.sentimentanalyzer.SYMBOLS_FILTER} value
 * @return {!proto.sentimentanalyzer.GetSymbolsReq} returns this
 */
proto.sentimentanalyzer.GetSymbolsReq.prototype.setFilter = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.sentimentanalyzer.GetSymbolsReply.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.sentimentanalyzer.GetSymbolsReply.prototype.toObject = function(opt_includeInstance) {
  return proto.sentimentanalyzer.GetSymbolsReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.sentimentanalyzer.GetSymbolsReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.sentimentanalyzer.GetSymbolsReply.toObject = function(includeInstance, msg) {
  var f, obj = {
symbolsList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.sentimentanalyzer.GetSymbolsReply}
 */
proto.sentimentanalyzer.GetSymbolsReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.sentimentanalyzer.GetSymbolsReply;
  return proto.sentimentanalyzer.GetSymbolsReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.sentimentanalyzer.GetSymbolsReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.sentimentanalyzer.GetSymbolsReply}
 */
proto.sentimentanalyzer.GetSymbolsReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.addSymbols(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.sentimentanalyzer.GetSymbolsReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.sentimentanalyzer.GetSymbolsReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.sentimentanalyzer.GetSymbolsReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.sentimentanalyzer.GetSymbolsReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSymbolsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      1,
      f
    );
  }
};


/**
 * repeated string symbols = 1;
 * @return {!Array<string>}
 */
proto.sentimentanalyzer.GetSymbolsReply.prototype.getSymbolsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.sentimentanalyzer.GetSymbolsReply} returns this
 */
proto.sentimentanalyzer.GetSymbolsReply.prototype.setSymbolsList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.sentimentanalyzer.GetSymbolsReply} returns this
 */
proto.sentimentanalyzer.GetSymbolsReply.prototype.addSymbols = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.sentimentanalyzer.GetSymbolsReply} returns this
 */
proto.sentimentanalyzer.GetSymbolsReply.prototype.clearSymbolsList = function() {
  return this.setSymbolsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.sentimentanalyzer.SentimentOverviewReq.prototype.toObject = function(opt_includeInstance) {
  return proto.sentimentanalyzer.SentimentOverviewReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.sentimentanalyzer.SentimentOverviewReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.sentimentanalyzer.SentimentOverviewReq.toObject = function(includeInstance, msg) {
  var f, obj = {
userId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.sentimentanalyzer.SentimentOverviewReq}
 */
proto.sentimentanalyzer.SentimentOverviewReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.sentimentanalyzer.SentimentOverviewReq;
  return proto.sentimentanalyzer.SentimentOverviewReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.sentimentanalyzer.SentimentOverviewReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.sentimentanalyzer.SentimentOverviewReq}
 */
proto.sentimentanalyzer.SentimentOverviewReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.sentimentanalyzer.SentimentOverviewReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.sentimentanalyzer.SentimentOverviewReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.sentimentanalyzer.SentimentOverviewReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.sentimentanalyzer.SentimentOverviewReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string user_id = 1;
 * @return {string}
 */
proto.sentimentanalyzer.SentimentOverviewReq.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.sentimentanalyzer.SentimentOverviewReq} returns this
 */
proto.sentimentanalyzer.SentimentOverviewReq.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.sentimentanalyzer.HotFxPair.prototype.toObject = function(opt_includeInstance) {
  return proto.sentimentanalyzer.HotFxPair.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.sentimentanalyzer.HotFxPair} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.sentimentanalyzer.HotFxPair.toObject = function(includeInstance, msg) {
  var f, obj = {
symbol: jspb.Message.getFieldWithDefault(msg, 1, ""),
total: jspb.Message.getFloatingPointFieldWithDefault(msg, 2, 0.0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.sentimentanalyzer.HotFxPair}
 */
proto.sentimentanalyzer.HotFxPair.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.sentimentanalyzer.HotFxPair;
  return proto.sentimentanalyzer.HotFxPair.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.sentimentanalyzer.HotFxPair} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.sentimentanalyzer.HotFxPair}
 */
proto.sentimentanalyzer.HotFxPair.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setSymbol(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setTotal(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.sentimentanalyzer.HotFxPair.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.sentimentanalyzer.HotFxPair.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.sentimentanalyzer.HotFxPair} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.sentimentanalyzer.HotFxPair.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSymbol();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getTotal();
  if (f !== 0.0) {
    writer.writeDouble(
      2,
      f
    );
  }
};


/**
 * optional string symbol = 1;
 * @return {string}
 */
proto.sentimentanalyzer.HotFxPair.prototype.getSymbol = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.sentimentanalyzer.HotFxPair} returns this
 */
proto.sentimentanalyzer.HotFxPair.prototype.setSymbol = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional double total = 2;
 * @return {number}
 */
proto.sentimentanalyzer.HotFxPair.prototype.getTotal = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 2, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.sentimentanalyzer.HotFxPair} returns this
 */
proto.sentimentanalyzer.HotFxPair.prototype.setTotal = function(value) {
  return jspb.Message.setProto3FloatField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.sentimentanalyzer.Bias.repeatedFields_ = [3,5];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.sentimentanalyzer.Bias.prototype.toObject = function(opt_includeInstance) {
  return proto.sentimentanalyzer.Bias.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.sentimentanalyzer.Bias} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.sentimentanalyzer.Bias.toObject = function(includeInstance, msg) {
  var f, obj = {
currency: jspb.Message.getFieldWithDefault(msg, 1, ""),
bias: jspb.Message.getFloatingPointFieldWithDefault(msg, 2, 0.0),
netLongsList: jspb.Message.toObjectList(msg.getNetLongsList(),
    proto.sentimentanalyzer.DateWiseData.toObject, includeInstance),
netLongDiff: jspb.Message.getFloatingPointFieldWithDefault(msg, 4, 0.0),
netShortsList: jspb.Message.toObjectList(msg.getNetShortsList(),
    proto.sentimentanalyzer.DateWiseData.toObject, includeInstance),
netShortsDiff: jspb.Message.getFloatingPointFieldWithDefault(msg, 6, 0.0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.sentimentanalyzer.Bias}
 */
proto.sentimentanalyzer.Bias.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.sentimentanalyzer.Bias;
  return proto.sentimentanalyzer.Bias.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.sentimentanalyzer.Bias} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.sentimentanalyzer.Bias}
 */
proto.sentimentanalyzer.Bias.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setCurrency(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setBias(value);
      break;
    case 3:
      var value = new proto.sentimentanalyzer.DateWiseData;
      reader.readMessage(value,proto.sentimentanalyzer.DateWiseData.deserializeBinaryFromReader);
      msg.addNetLongs(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setNetLongDiff(value);
      break;
    case 5:
      var value = new proto.sentimentanalyzer.DateWiseData;
      reader.readMessage(value,proto.sentimentanalyzer.DateWiseData.deserializeBinaryFromReader);
      msg.addNetShorts(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setNetShortsDiff(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.sentimentanalyzer.Bias.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.sentimentanalyzer.Bias.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.sentimentanalyzer.Bias} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.sentimentanalyzer.Bias.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCurrency();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getBias();
  if (f !== 0.0) {
    writer.writeDouble(
      2,
      f
    );
  }
  f = message.getNetLongsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.sentimentanalyzer.DateWiseData.serializeBinaryToWriter
    );
  }
  f = message.getNetLongDiff();
  if (f !== 0.0) {
    writer.writeDouble(
      4,
      f
    );
  }
  f = message.getNetShortsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      5,
      f,
      proto.sentimentanalyzer.DateWiseData.serializeBinaryToWriter
    );
  }
  f = message.getNetShortsDiff();
  if (f !== 0.0) {
    writer.writeDouble(
      6,
      f
    );
  }
};


/**
 * optional string currency = 1;
 * @return {string}
 */
proto.sentimentanalyzer.Bias.prototype.getCurrency = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.sentimentanalyzer.Bias} returns this
 */
proto.sentimentanalyzer.Bias.prototype.setCurrency = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional double bias = 2;
 * @return {number}
 */
proto.sentimentanalyzer.Bias.prototype.getBias = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 2, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.sentimentanalyzer.Bias} returns this
 */
proto.sentimentanalyzer.Bias.prototype.setBias = function(value) {
  return jspb.Message.setProto3FloatField(this, 2, value);
};


/**
 * repeated DateWiseData net_longs = 3;
 * @return {!Array<!proto.sentimentanalyzer.DateWiseData>}
 */
proto.sentimentanalyzer.Bias.prototype.getNetLongsList = function() {
  return /** @type{!Array<!proto.sentimentanalyzer.DateWiseData>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.sentimentanalyzer.DateWiseData, 3));
};


/**
 * @param {!Array<!proto.sentimentanalyzer.DateWiseData>} value
 * @return {!proto.sentimentanalyzer.Bias} returns this
*/
proto.sentimentanalyzer.Bias.prototype.setNetLongsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.sentimentanalyzer.DateWiseData=} opt_value
 * @param {number=} opt_index
 * @return {!proto.sentimentanalyzer.DateWiseData}
 */
proto.sentimentanalyzer.Bias.prototype.addNetLongs = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.sentimentanalyzer.DateWiseData, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.sentimentanalyzer.Bias} returns this
 */
proto.sentimentanalyzer.Bias.prototype.clearNetLongsList = function() {
  return this.setNetLongsList([]);
};


/**
 * optional double net_long_diff = 4;
 * @return {number}
 */
proto.sentimentanalyzer.Bias.prototype.getNetLongDiff = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 4, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.sentimentanalyzer.Bias} returns this
 */
proto.sentimentanalyzer.Bias.prototype.setNetLongDiff = function(value) {
  return jspb.Message.setProto3FloatField(this, 4, value);
};


/**
 * repeated DateWiseData net_shorts = 5;
 * @return {!Array<!proto.sentimentanalyzer.DateWiseData>}
 */
proto.sentimentanalyzer.Bias.prototype.getNetShortsList = function() {
  return /** @type{!Array<!proto.sentimentanalyzer.DateWiseData>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.sentimentanalyzer.DateWiseData, 5));
};


/**
 * @param {!Array<!proto.sentimentanalyzer.DateWiseData>} value
 * @return {!proto.sentimentanalyzer.Bias} returns this
*/
proto.sentimentanalyzer.Bias.prototype.setNetShortsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 5, value);
};


/**
 * @param {!proto.sentimentanalyzer.DateWiseData=} opt_value
 * @param {number=} opt_index
 * @return {!proto.sentimentanalyzer.DateWiseData}
 */
proto.sentimentanalyzer.Bias.prototype.addNetShorts = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 5, opt_value, proto.sentimentanalyzer.DateWiseData, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.sentimentanalyzer.Bias} returns this
 */
proto.sentimentanalyzer.Bias.prototype.clearNetShortsList = function() {
  return this.setNetShortsList([]);
};


/**
 * optional double net_shorts_diff = 6;
 * @return {number}
 */
proto.sentimentanalyzer.Bias.prototype.getNetShortsDiff = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 6, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.sentimentanalyzer.Bias} returns this
 */
proto.sentimentanalyzer.Bias.prototype.setNetShortsDiff = function(value) {
  return jspb.Message.setProto3FloatField(this, 6, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.sentimentanalyzer.DateWiseData.prototype.toObject = function(opt_includeInstance) {
  return proto.sentimentanalyzer.DateWiseData.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.sentimentanalyzer.DateWiseData} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.sentimentanalyzer.DateWiseData.toObject = function(includeInstance, msg) {
  var f, obj = {
date: jspb.Message.getFieldWithDefault(msg, 1, ""),
value: jspb.Message.getFloatingPointFieldWithDefault(msg, 2, 0.0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.sentimentanalyzer.DateWiseData}
 */
proto.sentimentanalyzer.DateWiseData.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.sentimentanalyzer.DateWiseData;
  return proto.sentimentanalyzer.DateWiseData.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.sentimentanalyzer.DateWiseData} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.sentimentanalyzer.DateWiseData}
 */
proto.sentimentanalyzer.DateWiseData.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setDate(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setValue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.sentimentanalyzer.DateWiseData.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.sentimentanalyzer.DateWiseData.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.sentimentanalyzer.DateWiseData} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.sentimentanalyzer.DateWiseData.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDate();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getValue();
  if (f !== 0.0) {
    writer.writeDouble(
      2,
      f
    );
  }
};


/**
 * optional string date = 1;
 * @return {string}
 */
proto.sentimentanalyzer.DateWiseData.prototype.getDate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.sentimentanalyzer.DateWiseData} returns this
 */
proto.sentimentanalyzer.DateWiseData.prototype.setDate = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional double value = 2;
 * @return {number}
 */
proto.sentimentanalyzer.DateWiseData.prototype.getValue = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 2, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.sentimentanalyzer.DateWiseData} returns this
 */
proto.sentimentanalyzer.DateWiseData.prototype.setValue = function(value) {
  return jspb.Message.setProto3FloatField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.sentimentanalyzer.SymbolBias.repeatedFields_ = [4];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.sentimentanalyzer.SymbolBias.prototype.toObject = function(opt_includeInstance) {
  return proto.sentimentanalyzer.SymbolBias.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.sentimentanalyzer.SymbolBias} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.sentimentanalyzer.SymbolBias.toObject = function(includeInstance, msg) {
  var f, obj = {
symbol: jspb.Message.getFieldWithDefault(msg, 1, ""),
firstCurrencyBias: (f = msg.getFirstCurrencyBias()) && proto.sentimentanalyzer.Bias.toObject(includeInstance, f),
secondCurrencyBias: (f = msg.getSecondCurrencyBias()) && proto.sentimentanalyzer.Bias.toObject(includeInstance, f),
momentumList: jspb.Message.toObjectList(msg.getMomentumList(),
    proto.sentimentanalyzer.DateWiseData.toObject, includeInstance),
momentumDiff: jspb.Message.getFloatingPointFieldWithDefault(msg, 5, 0.0),
currentPrice: jspb.Message.getFloatingPointFieldWithDefault(msg, 6, 0.0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.sentimentanalyzer.SymbolBias}
 */
proto.sentimentanalyzer.SymbolBias.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.sentimentanalyzer.SymbolBias;
  return proto.sentimentanalyzer.SymbolBias.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.sentimentanalyzer.SymbolBias} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.sentimentanalyzer.SymbolBias}
 */
proto.sentimentanalyzer.SymbolBias.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setSymbol(value);
      break;
    case 2:
      var value = new proto.sentimentanalyzer.Bias;
      reader.readMessage(value,proto.sentimentanalyzer.Bias.deserializeBinaryFromReader);
      msg.setFirstCurrencyBias(value);
      break;
    case 3:
      var value = new proto.sentimentanalyzer.Bias;
      reader.readMessage(value,proto.sentimentanalyzer.Bias.deserializeBinaryFromReader);
      msg.setSecondCurrencyBias(value);
      break;
    case 4:
      var value = new proto.sentimentanalyzer.DateWiseData;
      reader.readMessage(value,proto.sentimentanalyzer.DateWiseData.deserializeBinaryFromReader);
      msg.addMomentum(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setMomentumDiff(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setCurrentPrice(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.sentimentanalyzer.SymbolBias.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.sentimentanalyzer.SymbolBias.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.sentimentanalyzer.SymbolBias} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.sentimentanalyzer.SymbolBias.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSymbol();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getFirstCurrencyBias();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.sentimentanalyzer.Bias.serializeBinaryToWriter
    );
  }
  f = message.getSecondCurrencyBias();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.sentimentanalyzer.Bias.serializeBinaryToWriter
    );
  }
  f = message.getMomentumList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      4,
      f,
      proto.sentimentanalyzer.DateWiseData.serializeBinaryToWriter
    );
  }
  f = message.getMomentumDiff();
  if (f !== 0.0) {
    writer.writeDouble(
      5,
      f
    );
  }
  f = message.getCurrentPrice();
  if (f !== 0.0) {
    writer.writeDouble(
      6,
      f
    );
  }
};


/**
 * optional string symbol = 1;
 * @return {string}
 */
proto.sentimentanalyzer.SymbolBias.prototype.getSymbol = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.sentimentanalyzer.SymbolBias} returns this
 */
proto.sentimentanalyzer.SymbolBias.prototype.setSymbol = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional Bias first_currency_bias = 2;
 * @return {?proto.sentimentanalyzer.Bias}
 */
proto.sentimentanalyzer.SymbolBias.prototype.getFirstCurrencyBias = function() {
  return /** @type{?proto.sentimentanalyzer.Bias} */ (
    jspb.Message.getWrapperField(this, proto.sentimentanalyzer.Bias, 2));
};


/**
 * @param {?proto.sentimentanalyzer.Bias|undefined} value
 * @return {!proto.sentimentanalyzer.SymbolBias} returns this
*/
proto.sentimentanalyzer.SymbolBias.prototype.setFirstCurrencyBias = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.sentimentanalyzer.SymbolBias} returns this
 */
proto.sentimentanalyzer.SymbolBias.prototype.clearFirstCurrencyBias = function() {
  return this.setFirstCurrencyBias(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.sentimentanalyzer.SymbolBias.prototype.hasFirstCurrencyBias = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional Bias second_currency_bias = 3;
 * @return {?proto.sentimentanalyzer.Bias}
 */
proto.sentimentanalyzer.SymbolBias.prototype.getSecondCurrencyBias = function() {
  return /** @type{?proto.sentimentanalyzer.Bias} */ (
    jspb.Message.getWrapperField(this, proto.sentimentanalyzer.Bias, 3));
};


/**
 * @param {?proto.sentimentanalyzer.Bias|undefined} value
 * @return {!proto.sentimentanalyzer.SymbolBias} returns this
*/
proto.sentimentanalyzer.SymbolBias.prototype.setSecondCurrencyBias = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.sentimentanalyzer.SymbolBias} returns this
 */
proto.sentimentanalyzer.SymbolBias.prototype.clearSecondCurrencyBias = function() {
  return this.setSecondCurrencyBias(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.sentimentanalyzer.SymbolBias.prototype.hasSecondCurrencyBias = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * repeated DateWiseData momentum = 4;
 * @return {!Array<!proto.sentimentanalyzer.DateWiseData>}
 */
proto.sentimentanalyzer.SymbolBias.prototype.getMomentumList = function() {
  return /** @type{!Array<!proto.sentimentanalyzer.DateWiseData>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.sentimentanalyzer.DateWiseData, 4));
};


/**
 * @param {!Array<!proto.sentimentanalyzer.DateWiseData>} value
 * @return {!proto.sentimentanalyzer.SymbolBias} returns this
*/
proto.sentimentanalyzer.SymbolBias.prototype.setMomentumList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 4, value);
};


/**
 * @param {!proto.sentimentanalyzer.DateWiseData=} opt_value
 * @param {number=} opt_index
 * @return {!proto.sentimentanalyzer.DateWiseData}
 */
proto.sentimentanalyzer.SymbolBias.prototype.addMomentum = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 4, opt_value, proto.sentimentanalyzer.DateWiseData, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.sentimentanalyzer.SymbolBias} returns this
 */
proto.sentimentanalyzer.SymbolBias.prototype.clearMomentumList = function() {
  return this.setMomentumList([]);
};


/**
 * optional double momentum_diff = 5;
 * @return {number}
 */
proto.sentimentanalyzer.SymbolBias.prototype.getMomentumDiff = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 5, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.sentimentanalyzer.SymbolBias} returns this
 */
proto.sentimentanalyzer.SymbolBias.prototype.setMomentumDiff = function(value) {
  return jspb.Message.setProto3FloatField(this, 5, value);
};


/**
 * optional double current_price = 6;
 * @return {number}
 */
proto.sentimentanalyzer.SymbolBias.prototype.getCurrentPrice = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 6, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.sentimentanalyzer.SymbolBias} returns this
 */
proto.sentimentanalyzer.SymbolBias.prototype.setCurrentPrice = function(value) {
  return jspb.Message.setProto3FloatField(this, 6, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.sentimentanalyzer.CurrencyStrength.prototype.toObject = function(opt_includeInstance) {
  return proto.sentimentanalyzer.CurrencyStrength.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.sentimentanalyzer.CurrencyStrength} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.sentimentanalyzer.CurrencyStrength.toObject = function(includeInstance, msg) {
  var f, obj = {
currency: jspb.Message.getFieldWithDefault(msg, 1, ""),
strength: jspb.Message.getFloatingPointFieldWithDefault(msg, 2, 0.0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.sentimentanalyzer.CurrencyStrength}
 */
proto.sentimentanalyzer.CurrencyStrength.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.sentimentanalyzer.CurrencyStrength;
  return proto.sentimentanalyzer.CurrencyStrength.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.sentimentanalyzer.CurrencyStrength} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.sentimentanalyzer.CurrencyStrength}
 */
proto.sentimentanalyzer.CurrencyStrength.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setCurrency(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setStrength(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.sentimentanalyzer.CurrencyStrength.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.sentimentanalyzer.CurrencyStrength.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.sentimentanalyzer.CurrencyStrength} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.sentimentanalyzer.CurrencyStrength.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCurrency();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getStrength();
  if (f !== 0.0) {
    writer.writeDouble(
      2,
      f
    );
  }
};


/**
 * optional string currency = 1;
 * @return {string}
 */
proto.sentimentanalyzer.CurrencyStrength.prototype.getCurrency = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.sentimentanalyzer.CurrencyStrength} returns this
 */
proto.sentimentanalyzer.CurrencyStrength.prototype.setCurrency = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional double strength = 2;
 * @return {number}
 */
proto.sentimentanalyzer.CurrencyStrength.prototype.getStrength = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 2, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.sentimentanalyzer.CurrencyStrength} returns this
 */
proto.sentimentanalyzer.CurrencyStrength.prototype.setStrength = function(value) {
  return jspb.Message.setProto3FloatField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.sentimentanalyzer.SentimentOverviewReply.repeatedFields_ = [7,8,9];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.sentimentanalyzer.SentimentOverviewReply.prototype.toObject = function(opt_includeInstance) {
  return proto.sentimentanalyzer.SentimentOverviewReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.sentimentanalyzer.SentimentOverviewReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.sentimentanalyzer.SentimentOverviewReply.toObject = function(includeInstance, msg) {
  var f, obj = {
userId: jspb.Message.getFieldWithDefault(msg, 1, ""),
usdIndex: jspb.Message.getFloatingPointFieldWithDefault(msg, 2, 0.0),
usdIndexDiff: jspb.Message.getFloatingPointFieldWithDefault(msg, 3, 0.0),
retailPositioning: jspb.Message.getFieldWithDefault(msg, 4, ""),
mentionVolumes: jspb.Message.getFloatingPointFieldWithDefault(msg, 5, 0.0),
mentionVolumesDiff: jspb.Message.getFloatingPointFieldWithDefault(msg, 6, 0.0),
hotFxPairsList: jspb.Message.toObjectList(msg.getHotFxPairsList(),
    proto.sentimentanalyzer.HotFxPair.toObject, includeInstance),
biasMetricsList: jspb.Message.toObjectList(msg.getBiasMetricsList(),
    proto.sentimentanalyzer.SymbolBias.toObject, includeInstance),
currencyStrengthList: jspb.Message.toObjectList(msg.getCurrencyStrengthList(),
    proto.sentimentanalyzer.CurrencyStrength.toObject, includeInstance),
riskTone: jspb.Message.getFloatingPointFieldWithDefault(msg, 10, 0.0),
riskToneMessage: jspb.Message.getFieldWithDefault(msg, 11, ""),
lastSyncedAt: (f = msg.getLastSyncedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.sentimentanalyzer.SentimentOverviewReply}
 */
proto.sentimentanalyzer.SentimentOverviewReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.sentimentanalyzer.SentimentOverviewReply;
  return proto.sentimentanalyzer.SentimentOverviewReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.sentimentanalyzer.SentimentOverviewReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.sentimentanalyzer.SentimentOverviewReply}
 */
proto.sentimentanalyzer.SentimentOverviewReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setUsdIndex(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setUsdIndexDiff(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setRetailPositioning(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setMentionVolumes(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setMentionVolumesDiff(value);
      break;
    case 7:
      var value = new proto.sentimentanalyzer.HotFxPair;
      reader.readMessage(value,proto.sentimentanalyzer.HotFxPair.deserializeBinaryFromReader);
      msg.addHotFxPairs(value);
      break;
    case 8:
      var value = new proto.sentimentanalyzer.SymbolBias;
      reader.readMessage(value,proto.sentimentanalyzer.SymbolBias.deserializeBinaryFromReader);
      msg.addBiasMetrics(value);
      break;
    case 9:
      var value = new proto.sentimentanalyzer.CurrencyStrength;
      reader.readMessage(value,proto.sentimentanalyzer.CurrencyStrength.deserializeBinaryFromReader);
      msg.addCurrencyStrength(value);
      break;
    case 10:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setRiskTone(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setRiskToneMessage(value);
      break;
    case 12:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setLastSyncedAt(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.sentimentanalyzer.SentimentOverviewReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.sentimentanalyzer.SentimentOverviewReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.sentimentanalyzer.SentimentOverviewReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.sentimentanalyzer.SentimentOverviewReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getUsdIndex();
  if (f !== 0.0) {
    writer.writeDouble(
      2,
      f
    );
  }
  f = message.getUsdIndexDiff();
  if (f !== 0.0) {
    writer.writeDouble(
      3,
      f
    );
  }
  f = message.getRetailPositioning();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getMentionVolumes();
  if (f !== 0.0) {
    writer.writeDouble(
      5,
      f
    );
  }
  f = message.getMentionVolumesDiff();
  if (f !== 0.0) {
    writer.writeDouble(
      6,
      f
    );
  }
  f = message.getHotFxPairsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      7,
      f,
      proto.sentimentanalyzer.HotFxPair.serializeBinaryToWriter
    );
  }
  f = message.getBiasMetricsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      8,
      f,
      proto.sentimentanalyzer.SymbolBias.serializeBinaryToWriter
    );
  }
  f = message.getCurrencyStrengthList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      9,
      f,
      proto.sentimentanalyzer.CurrencyStrength.serializeBinaryToWriter
    );
  }
  f = message.getRiskTone();
  if (f !== 0.0) {
    writer.writeDouble(
      10,
      f
    );
  }
  f = message.getRiskToneMessage();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
  f = message.getLastSyncedAt();
  if (f != null) {
    writer.writeMessage(
      12,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
};


/**
 * optional string user_id = 1;
 * @return {string}
 */
proto.sentimentanalyzer.SentimentOverviewReply.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.sentimentanalyzer.SentimentOverviewReply} returns this
 */
proto.sentimentanalyzer.SentimentOverviewReply.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional double usd_index = 2;
 * @return {number}
 */
proto.sentimentanalyzer.SentimentOverviewReply.prototype.getUsdIndex = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 2, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.sentimentanalyzer.SentimentOverviewReply} returns this
 */
proto.sentimentanalyzer.SentimentOverviewReply.prototype.setUsdIndex = function(value) {
  return jspb.Message.setProto3FloatField(this, 2, value);
};


/**
 * optional double usd_index_diff = 3;
 * @return {number}
 */
proto.sentimentanalyzer.SentimentOverviewReply.prototype.getUsdIndexDiff = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 3, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.sentimentanalyzer.SentimentOverviewReply} returns this
 */
proto.sentimentanalyzer.SentimentOverviewReply.prototype.setUsdIndexDiff = function(value) {
  return jspb.Message.setProto3FloatField(this, 3, value);
};


/**
 * optional string retail_positioning = 4;
 * @return {string}
 */
proto.sentimentanalyzer.SentimentOverviewReply.prototype.getRetailPositioning = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.sentimentanalyzer.SentimentOverviewReply} returns this
 */
proto.sentimentanalyzer.SentimentOverviewReply.prototype.setRetailPositioning = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional double mention_volumes = 5;
 * @return {number}
 */
proto.sentimentanalyzer.SentimentOverviewReply.prototype.getMentionVolumes = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 5, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.sentimentanalyzer.SentimentOverviewReply} returns this
 */
proto.sentimentanalyzer.SentimentOverviewReply.prototype.setMentionVolumes = function(value) {
  return jspb.Message.setProto3FloatField(this, 5, value);
};


/**
 * optional double mention_volumes_diff = 6;
 * @return {number}
 */
proto.sentimentanalyzer.SentimentOverviewReply.prototype.getMentionVolumesDiff = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 6, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.sentimentanalyzer.SentimentOverviewReply} returns this
 */
proto.sentimentanalyzer.SentimentOverviewReply.prototype.setMentionVolumesDiff = function(value) {
  return jspb.Message.setProto3FloatField(this, 6, value);
};


/**
 * repeated HotFxPair hot_fx_pairs = 7;
 * @return {!Array<!proto.sentimentanalyzer.HotFxPair>}
 */
proto.sentimentanalyzer.SentimentOverviewReply.prototype.getHotFxPairsList = function() {
  return /** @type{!Array<!proto.sentimentanalyzer.HotFxPair>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.sentimentanalyzer.HotFxPair, 7));
};


/**
 * @param {!Array<!proto.sentimentanalyzer.HotFxPair>} value
 * @return {!proto.sentimentanalyzer.SentimentOverviewReply} returns this
*/
proto.sentimentanalyzer.SentimentOverviewReply.prototype.setHotFxPairsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 7, value);
};


/**
 * @param {!proto.sentimentanalyzer.HotFxPair=} opt_value
 * @param {number=} opt_index
 * @return {!proto.sentimentanalyzer.HotFxPair}
 */
proto.sentimentanalyzer.SentimentOverviewReply.prototype.addHotFxPairs = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 7, opt_value, proto.sentimentanalyzer.HotFxPair, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.sentimentanalyzer.SentimentOverviewReply} returns this
 */
proto.sentimentanalyzer.SentimentOverviewReply.prototype.clearHotFxPairsList = function() {
  return this.setHotFxPairsList([]);
};


/**
 * repeated SymbolBias bias_metrics = 8;
 * @return {!Array<!proto.sentimentanalyzer.SymbolBias>}
 */
proto.sentimentanalyzer.SentimentOverviewReply.prototype.getBiasMetricsList = function() {
  return /** @type{!Array<!proto.sentimentanalyzer.SymbolBias>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.sentimentanalyzer.SymbolBias, 8));
};


/**
 * @param {!Array<!proto.sentimentanalyzer.SymbolBias>} value
 * @return {!proto.sentimentanalyzer.SentimentOverviewReply} returns this
*/
proto.sentimentanalyzer.SentimentOverviewReply.prototype.setBiasMetricsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 8, value);
};


/**
 * @param {!proto.sentimentanalyzer.SymbolBias=} opt_value
 * @param {number=} opt_index
 * @return {!proto.sentimentanalyzer.SymbolBias}
 */
proto.sentimentanalyzer.SentimentOverviewReply.prototype.addBiasMetrics = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 8, opt_value, proto.sentimentanalyzer.SymbolBias, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.sentimentanalyzer.SentimentOverviewReply} returns this
 */
proto.sentimentanalyzer.SentimentOverviewReply.prototype.clearBiasMetricsList = function() {
  return this.setBiasMetricsList([]);
};


/**
 * repeated CurrencyStrength currency_strength = 9;
 * @return {!Array<!proto.sentimentanalyzer.CurrencyStrength>}
 */
proto.sentimentanalyzer.SentimentOverviewReply.prototype.getCurrencyStrengthList = function() {
  return /** @type{!Array<!proto.sentimentanalyzer.CurrencyStrength>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.sentimentanalyzer.CurrencyStrength, 9));
};


/**
 * @param {!Array<!proto.sentimentanalyzer.CurrencyStrength>} value
 * @return {!proto.sentimentanalyzer.SentimentOverviewReply} returns this
*/
proto.sentimentanalyzer.SentimentOverviewReply.prototype.setCurrencyStrengthList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 9, value);
};


/**
 * @param {!proto.sentimentanalyzer.CurrencyStrength=} opt_value
 * @param {number=} opt_index
 * @return {!proto.sentimentanalyzer.CurrencyStrength}
 */
proto.sentimentanalyzer.SentimentOverviewReply.prototype.addCurrencyStrength = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 9, opt_value, proto.sentimentanalyzer.CurrencyStrength, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.sentimentanalyzer.SentimentOverviewReply} returns this
 */
proto.sentimentanalyzer.SentimentOverviewReply.prototype.clearCurrencyStrengthList = function() {
  return this.setCurrencyStrengthList([]);
};


/**
 * optional double risk_tone = 10;
 * @return {number}
 */
proto.sentimentanalyzer.SentimentOverviewReply.prototype.getRiskTone = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 10, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.sentimentanalyzer.SentimentOverviewReply} returns this
 */
proto.sentimentanalyzer.SentimentOverviewReply.prototype.setRiskTone = function(value) {
  return jspb.Message.setProto3FloatField(this, 10, value);
};


/**
 * optional string risk_tone_message = 11;
 * @return {string}
 */
proto.sentimentanalyzer.SentimentOverviewReply.prototype.getRiskToneMessage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/**
 * @param {string} value
 * @return {!proto.sentimentanalyzer.SentimentOverviewReply} returns this
 */
proto.sentimentanalyzer.SentimentOverviewReply.prototype.setRiskToneMessage = function(value) {
  return jspb.Message.setProto3StringField(this, 11, value);
};


/**
 * optional google.protobuf.Timestamp last_synced_at = 12;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.sentimentanalyzer.SentimentOverviewReply.prototype.getLastSyncedAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 12));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.sentimentanalyzer.SentimentOverviewReply} returns this
*/
proto.sentimentanalyzer.SentimentOverviewReply.prototype.setLastSyncedAt = function(value) {
  return jspb.Message.setWrapperField(this, 12, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.sentimentanalyzer.SentimentOverviewReply} returns this
 */
proto.sentimentanalyzer.SentimentOverviewReply.prototype.clearLastSyncedAt = function() {
  return this.setLastSyncedAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.sentimentanalyzer.SentimentOverviewReply.prototype.hasLastSyncedAt = function() {
  return jspb.Message.getField(this, 12) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.sentimentanalyzer.GetSymbolsSentimentReq.prototype.toObject = function(opt_includeInstance) {
  return proto.sentimentanalyzer.GetSymbolsSentimentReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.sentimentanalyzer.GetSymbolsSentimentReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.sentimentanalyzer.GetSymbolsSentimentReq.toObject = function(includeInstance, msg) {
  var f, obj = {
userId: jspb.Message.getFieldWithDefault(msg, 1, ""),
query: jspb.Message.getFieldWithDefault(msg, 2, ""),
paginationCursor: jspb.Message.getFieldWithDefault(msg, 3, ""),
pageSize: jspb.Message.getFieldWithDefault(msg, 4, 0),
sentimentTrendFilter: jspb.Message.getFieldWithDefault(msg, 5, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.sentimentanalyzer.GetSymbolsSentimentReq}
 */
proto.sentimentanalyzer.GetSymbolsSentimentReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.sentimentanalyzer.GetSymbolsSentimentReq;
  return proto.sentimentanalyzer.GetSymbolsSentimentReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.sentimentanalyzer.GetSymbolsSentimentReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.sentimentanalyzer.GetSymbolsSentimentReq}
 */
proto.sentimentanalyzer.GetSymbolsSentimentReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setQuery(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setPaginationCursor(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setPageSize(value);
      break;
    case 5:
      var value = /** @type {!proto.sentimentanalyzer.SENTIMENT_TREND} */ (reader.readEnum());
      msg.setSentimentTrendFilter(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.sentimentanalyzer.GetSymbolsSentimentReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.sentimentanalyzer.GetSymbolsSentimentReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.sentimentanalyzer.GetSymbolsSentimentReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.sentimentanalyzer.GetSymbolsSentimentReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getQuery();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getPaginationCursor();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getPageSize();
  if (f !== 0) {
    writer.writeUint32(
      4,
      f
    );
  }
  f = message.getSentimentTrendFilter();
  if (f !== 0.0) {
    writer.writeEnum(
      5,
      f
    );
  }
};


/**
 * optional string user_id = 1;
 * @return {string}
 */
proto.sentimentanalyzer.GetSymbolsSentimentReq.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.sentimentanalyzer.GetSymbolsSentimentReq} returns this
 */
proto.sentimentanalyzer.GetSymbolsSentimentReq.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string query = 2;
 * @return {string}
 */
proto.sentimentanalyzer.GetSymbolsSentimentReq.prototype.getQuery = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.sentimentanalyzer.GetSymbolsSentimentReq} returns this
 */
proto.sentimentanalyzer.GetSymbolsSentimentReq.prototype.setQuery = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string pagination_cursor = 3;
 * @return {string}
 */
proto.sentimentanalyzer.GetSymbolsSentimentReq.prototype.getPaginationCursor = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.sentimentanalyzer.GetSymbolsSentimentReq} returns this
 */
proto.sentimentanalyzer.GetSymbolsSentimentReq.prototype.setPaginationCursor = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional uint32 page_size = 4;
 * @return {number}
 */
proto.sentimentanalyzer.GetSymbolsSentimentReq.prototype.getPageSize = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.sentimentanalyzer.GetSymbolsSentimentReq} returns this
 */
proto.sentimentanalyzer.GetSymbolsSentimentReq.prototype.setPageSize = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional SENTIMENT_TREND sentiment_trend_filter = 5;
 * @return {!proto.sentimentanalyzer.SENTIMENT_TREND}
 */
proto.sentimentanalyzer.GetSymbolsSentimentReq.prototype.getSentimentTrendFilter = function() {
  return /** @type {!proto.sentimentanalyzer.SENTIMENT_TREND} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {!proto.sentimentanalyzer.SENTIMENT_TREND} value
 * @return {!proto.sentimentanalyzer.GetSymbolsSentimentReq} returns this
 */
proto.sentimentanalyzer.GetSymbolsSentimentReq.prototype.setSentimentTrendFilter = function(value) {
  return jspb.Message.setProto3EnumField(this, 5, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.sentimentanalyzer.SymbolInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.sentimentanalyzer.SymbolInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.sentimentanalyzer.SymbolInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.sentimentanalyzer.SymbolInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
name: jspb.Message.getFieldWithDefault(msg, 1, ""),
avgBuyPrice: jspb.Message.getFieldWithDefault(msg, 2, ""),
avgSellPrice: jspb.Message.getFieldWithDefault(msg, 3, ""),
buyPriceDiff: jspb.Message.getFieldWithDefault(msg, 4, ""),
sellPriceDiff: jspb.Message.getFieldWithDefault(msg, 5, ""),
currentPrice: jspb.Message.getFieldWithDefault(msg, 6, ""),
buyPercentage: jspb.Message.getFloatingPointFieldWithDefault(msg, 7, 0.0),
sellPercentage: jspb.Message.getFloatingPointFieldWithDefault(msg, 8, 0.0),
symbolPopularity: jspb.Message.getFloatingPointFieldWithDefault(msg, 9, 0.0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.sentimentanalyzer.SymbolInfo}
 */
proto.sentimentanalyzer.SymbolInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.sentimentanalyzer.SymbolInfo;
  return proto.sentimentanalyzer.SymbolInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.sentimentanalyzer.SymbolInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.sentimentanalyzer.SymbolInfo}
 */
proto.sentimentanalyzer.SymbolInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setAvgBuyPrice(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setAvgSellPrice(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setBuyPriceDiff(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setSellPriceDiff(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setCurrentPrice(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setBuyPercentage(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setSellPercentage(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setSymbolPopularity(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.sentimentanalyzer.SymbolInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.sentimentanalyzer.SymbolInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.sentimentanalyzer.SymbolInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.sentimentanalyzer.SymbolInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getAvgBuyPrice();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getAvgSellPrice();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getBuyPriceDiff();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getSellPriceDiff();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getCurrentPrice();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getBuyPercentage();
  if (f !== 0.0) {
    writer.writeDouble(
      7,
      f
    );
  }
  f = message.getSellPercentage();
  if (f !== 0.0) {
    writer.writeDouble(
      8,
      f
    );
  }
  f = message.getSymbolPopularity();
  if (f !== 0.0) {
    writer.writeDouble(
      9,
      f
    );
  }
};


/**
 * optional string name = 1;
 * @return {string}
 */
proto.sentimentanalyzer.SymbolInfo.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.sentimentanalyzer.SymbolInfo} returns this
 */
proto.sentimentanalyzer.SymbolInfo.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string avg_buy_price = 2;
 * @return {string}
 */
proto.sentimentanalyzer.SymbolInfo.prototype.getAvgBuyPrice = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.sentimentanalyzer.SymbolInfo} returns this
 */
proto.sentimentanalyzer.SymbolInfo.prototype.setAvgBuyPrice = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string avg_sell_price = 3;
 * @return {string}
 */
proto.sentimentanalyzer.SymbolInfo.prototype.getAvgSellPrice = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.sentimentanalyzer.SymbolInfo} returns this
 */
proto.sentimentanalyzer.SymbolInfo.prototype.setAvgSellPrice = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string buy_price_diff = 4;
 * @return {string}
 */
proto.sentimentanalyzer.SymbolInfo.prototype.getBuyPriceDiff = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.sentimentanalyzer.SymbolInfo} returns this
 */
proto.sentimentanalyzer.SymbolInfo.prototype.setBuyPriceDiff = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string sell_price_diff = 5;
 * @return {string}
 */
proto.sentimentanalyzer.SymbolInfo.prototype.getSellPriceDiff = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.sentimentanalyzer.SymbolInfo} returns this
 */
proto.sentimentanalyzer.SymbolInfo.prototype.setSellPriceDiff = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string current_price = 6;
 * @return {string}
 */
proto.sentimentanalyzer.SymbolInfo.prototype.getCurrentPrice = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.sentimentanalyzer.SymbolInfo} returns this
 */
proto.sentimentanalyzer.SymbolInfo.prototype.setCurrentPrice = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional double buy_percentage = 7;
 * @return {number}
 */
proto.sentimentanalyzer.SymbolInfo.prototype.getBuyPercentage = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 7, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.sentimentanalyzer.SymbolInfo} returns this
 */
proto.sentimentanalyzer.SymbolInfo.prototype.setBuyPercentage = function(value) {
  return jspb.Message.setProto3FloatField(this, 7, value);
};


/**
 * optional double sell_percentage = 8;
 * @return {number}
 */
proto.sentimentanalyzer.SymbolInfo.prototype.getSellPercentage = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 8, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.sentimentanalyzer.SymbolInfo} returns this
 */
proto.sentimentanalyzer.SymbolInfo.prototype.setSellPercentage = function(value) {
  return jspb.Message.setProto3FloatField(this, 8, value);
};


/**
 * optional double symbol_popularity = 9;
 * @return {number}
 */
proto.sentimentanalyzer.SymbolInfo.prototype.getSymbolPopularity = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 9, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.sentimentanalyzer.SymbolInfo} returns this
 */
proto.sentimentanalyzer.SymbolInfo.prototype.setSymbolPopularity = function(value) {
  return jspb.Message.setProto3FloatField(this, 9, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.sentimentanalyzer.GetSymbolsSentimentReply.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.sentimentanalyzer.GetSymbolsSentimentReply.prototype.toObject = function(opt_includeInstance) {
  return proto.sentimentanalyzer.GetSymbolsSentimentReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.sentimentanalyzer.GetSymbolsSentimentReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.sentimentanalyzer.GetSymbolsSentimentReply.toObject = function(includeInstance, msg) {
  var f, obj = {
symbolInfosList: jspb.Message.toObjectList(msg.getSymbolInfosList(),
    proto.sentimentanalyzer.SymbolInfo.toObject, includeInstance),
nextPageCursor: jspb.Message.getFieldWithDefault(msg, 2, ""),
pageSize: jspb.Message.getFieldWithDefault(msg, 3, 0),
count: jspb.Message.getFieldWithDefault(msg, 4, 0),
lastSyncedAt: (f = msg.getLastSyncedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.sentimentanalyzer.GetSymbolsSentimentReply}
 */
proto.sentimentanalyzer.GetSymbolsSentimentReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.sentimentanalyzer.GetSymbolsSentimentReply;
  return proto.sentimentanalyzer.GetSymbolsSentimentReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.sentimentanalyzer.GetSymbolsSentimentReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.sentimentanalyzer.GetSymbolsSentimentReply}
 */
proto.sentimentanalyzer.GetSymbolsSentimentReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.sentimentanalyzer.SymbolInfo;
      reader.readMessage(value,proto.sentimentanalyzer.SymbolInfo.deserializeBinaryFromReader);
      msg.addSymbolInfos(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setNextPageCursor(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setPageSize(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCount(value);
      break;
    case 5:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setLastSyncedAt(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.sentimentanalyzer.GetSymbolsSentimentReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.sentimentanalyzer.GetSymbolsSentimentReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.sentimentanalyzer.GetSymbolsSentimentReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.sentimentanalyzer.GetSymbolsSentimentReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSymbolInfosList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.sentimentanalyzer.SymbolInfo.serializeBinaryToWriter
    );
  }
  f = message.getNextPageCursor();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getPageSize();
  if (f !== 0) {
    writer.writeUint32(
      3,
      f
    );
  }
  f = message.getCount();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
  f = message.getLastSyncedAt();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
};


/**
 * repeated SymbolInfo symbol_infos = 1;
 * @return {!Array<!proto.sentimentanalyzer.SymbolInfo>}
 */
proto.sentimentanalyzer.GetSymbolsSentimentReply.prototype.getSymbolInfosList = function() {
  return /** @type{!Array<!proto.sentimentanalyzer.SymbolInfo>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.sentimentanalyzer.SymbolInfo, 1));
};


/**
 * @param {!Array<!proto.sentimentanalyzer.SymbolInfo>} value
 * @return {!proto.sentimentanalyzer.GetSymbolsSentimentReply} returns this
*/
proto.sentimentanalyzer.GetSymbolsSentimentReply.prototype.setSymbolInfosList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.sentimentanalyzer.SymbolInfo=} opt_value
 * @param {number=} opt_index
 * @return {!proto.sentimentanalyzer.SymbolInfo}
 */
proto.sentimentanalyzer.GetSymbolsSentimentReply.prototype.addSymbolInfos = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.sentimentanalyzer.SymbolInfo, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.sentimentanalyzer.GetSymbolsSentimentReply} returns this
 */
proto.sentimentanalyzer.GetSymbolsSentimentReply.prototype.clearSymbolInfosList = function() {
  return this.setSymbolInfosList([]);
};


/**
 * optional string next_page_cursor = 2;
 * @return {string}
 */
proto.sentimentanalyzer.GetSymbolsSentimentReply.prototype.getNextPageCursor = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.sentimentanalyzer.GetSymbolsSentimentReply} returns this
 */
proto.sentimentanalyzer.GetSymbolsSentimentReply.prototype.setNextPageCursor = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional uint32 page_size = 3;
 * @return {number}
 */
proto.sentimentanalyzer.GetSymbolsSentimentReply.prototype.getPageSize = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.sentimentanalyzer.GetSymbolsSentimentReply} returns this
 */
proto.sentimentanalyzer.GetSymbolsSentimentReply.prototype.setPageSize = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int64 count = 4;
 * @return {number}
 */
proto.sentimentanalyzer.GetSymbolsSentimentReply.prototype.getCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.sentimentanalyzer.GetSymbolsSentimentReply} returns this
 */
proto.sentimentanalyzer.GetSymbolsSentimentReply.prototype.setCount = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional google.protobuf.Timestamp last_synced_at = 5;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.sentimentanalyzer.GetSymbolsSentimentReply.prototype.getLastSyncedAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 5));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.sentimentanalyzer.GetSymbolsSentimentReply} returns this
*/
proto.sentimentanalyzer.GetSymbolsSentimentReply.prototype.setLastSyncedAt = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.sentimentanalyzer.GetSymbolsSentimentReply} returns this
 */
proto.sentimentanalyzer.GetSymbolsSentimentReply.prototype.clearLastSyncedAt = function() {
  return this.setLastSyncedAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.sentimentanalyzer.GetSymbolsSentimentReply.prototype.hasLastSyncedAt = function() {
  return jspb.Message.getField(this, 5) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.sentimentanalyzer.GetBrokersSymbolSentimentReq.prototype.toObject = function(opt_includeInstance) {
  return proto.sentimentanalyzer.GetBrokersSymbolSentimentReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.sentimentanalyzer.GetBrokersSymbolSentimentReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.sentimentanalyzer.GetBrokersSymbolSentimentReq.toObject = function(includeInstance, msg) {
  var f, obj = {
userId: jspb.Message.getFieldWithDefault(msg, 1, ""),
symbol: jspb.Message.getFieldWithDefault(msg, 2, ""),
paginationCursor: jspb.Message.getFieldWithDefault(msg, 3, ""),
pageSize: jspb.Message.getFieldWithDefault(msg, 4, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.sentimentanalyzer.GetBrokersSymbolSentimentReq}
 */
proto.sentimentanalyzer.GetBrokersSymbolSentimentReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.sentimentanalyzer.GetBrokersSymbolSentimentReq;
  return proto.sentimentanalyzer.GetBrokersSymbolSentimentReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.sentimentanalyzer.GetBrokersSymbolSentimentReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.sentimentanalyzer.GetBrokersSymbolSentimentReq}
 */
proto.sentimentanalyzer.GetBrokersSymbolSentimentReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setSymbol(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setPaginationCursor(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setPageSize(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.sentimentanalyzer.GetBrokersSymbolSentimentReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.sentimentanalyzer.GetBrokersSymbolSentimentReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.sentimentanalyzer.GetBrokersSymbolSentimentReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.sentimentanalyzer.GetBrokersSymbolSentimentReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getSymbol();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getPaginationCursor();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getPageSize();
  if (f !== 0) {
    writer.writeUint32(
      4,
      f
    );
  }
};


/**
 * optional string user_id = 1;
 * @return {string}
 */
proto.sentimentanalyzer.GetBrokersSymbolSentimentReq.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.sentimentanalyzer.GetBrokersSymbolSentimentReq} returns this
 */
proto.sentimentanalyzer.GetBrokersSymbolSentimentReq.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string symbol = 2;
 * @return {string}
 */
proto.sentimentanalyzer.GetBrokersSymbolSentimentReq.prototype.getSymbol = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.sentimentanalyzer.GetBrokersSymbolSentimentReq} returns this
 */
proto.sentimentanalyzer.GetBrokersSymbolSentimentReq.prototype.setSymbol = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string pagination_cursor = 3;
 * @return {string}
 */
proto.sentimentanalyzer.GetBrokersSymbolSentimentReq.prototype.getPaginationCursor = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.sentimentanalyzer.GetBrokersSymbolSentimentReq} returns this
 */
proto.sentimentanalyzer.GetBrokersSymbolSentimentReq.prototype.setPaginationCursor = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional uint32 page_size = 4;
 * @return {number}
 */
proto.sentimentanalyzer.GetBrokersSymbolSentimentReq.prototype.getPageSize = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.sentimentanalyzer.GetBrokersSymbolSentimentReq} returns this
 */
proto.sentimentanalyzer.GetBrokersSymbolSentimentReq.prototype.setPageSize = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.sentimentanalyzer.BrokerSymbolInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.sentimentanalyzer.BrokerSymbolInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.sentimentanalyzer.BrokerSymbolInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.sentimentanalyzer.BrokerSymbolInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
brokerName: jspb.Message.getFieldWithDefault(msg, 1, ""),
symbolName: jspb.Message.getFieldWithDefault(msg, 2, ""),
buyPercentage: jspb.Message.getFloatingPointFieldWithDefault(msg, 3, 0.0),
sellPercentage: jspb.Message.getFloatingPointFieldWithDefault(msg, 4, 0.0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.sentimentanalyzer.BrokerSymbolInfo}
 */
proto.sentimentanalyzer.BrokerSymbolInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.sentimentanalyzer.BrokerSymbolInfo;
  return proto.sentimentanalyzer.BrokerSymbolInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.sentimentanalyzer.BrokerSymbolInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.sentimentanalyzer.BrokerSymbolInfo}
 */
proto.sentimentanalyzer.BrokerSymbolInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setBrokerName(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setSymbolName(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setBuyPercentage(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setSellPercentage(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.sentimentanalyzer.BrokerSymbolInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.sentimentanalyzer.BrokerSymbolInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.sentimentanalyzer.BrokerSymbolInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.sentimentanalyzer.BrokerSymbolInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBrokerName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getSymbolName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getBuyPercentage();
  if (f !== 0.0) {
    writer.writeDouble(
      3,
      f
    );
  }
  f = message.getSellPercentage();
  if (f !== 0.0) {
    writer.writeDouble(
      4,
      f
    );
  }
};


/**
 * optional string broker_name = 1;
 * @return {string}
 */
proto.sentimentanalyzer.BrokerSymbolInfo.prototype.getBrokerName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.sentimentanalyzer.BrokerSymbolInfo} returns this
 */
proto.sentimentanalyzer.BrokerSymbolInfo.prototype.setBrokerName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string symbol_name = 2;
 * @return {string}
 */
proto.sentimentanalyzer.BrokerSymbolInfo.prototype.getSymbolName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.sentimentanalyzer.BrokerSymbolInfo} returns this
 */
proto.sentimentanalyzer.BrokerSymbolInfo.prototype.setSymbolName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional double buy_percentage = 3;
 * @return {number}
 */
proto.sentimentanalyzer.BrokerSymbolInfo.prototype.getBuyPercentage = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 3, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.sentimentanalyzer.BrokerSymbolInfo} returns this
 */
proto.sentimentanalyzer.BrokerSymbolInfo.prototype.setBuyPercentage = function(value) {
  return jspb.Message.setProto3FloatField(this, 3, value);
};


/**
 * optional double sell_percentage = 4;
 * @return {number}
 */
proto.sentimentanalyzer.BrokerSymbolInfo.prototype.getSellPercentage = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 4, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.sentimentanalyzer.BrokerSymbolInfo} returns this
 */
proto.sentimentanalyzer.BrokerSymbolInfo.prototype.setSellPercentage = function(value) {
  return jspb.Message.setProto3FloatField(this, 4, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.sentimentanalyzer.GetBrokersSymbolSentimentReply.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.sentimentanalyzer.GetBrokersSymbolSentimentReply.prototype.toObject = function(opt_includeInstance) {
  return proto.sentimentanalyzer.GetBrokersSymbolSentimentReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.sentimentanalyzer.GetBrokersSymbolSentimentReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.sentimentanalyzer.GetBrokersSymbolSentimentReply.toObject = function(includeInstance, msg) {
  var f, obj = {
brokerSymbolInfosList: jspb.Message.toObjectList(msg.getBrokerSymbolInfosList(),
    proto.sentimentanalyzer.BrokerSymbolInfo.toObject, includeInstance),
nextPageCursor: jspb.Message.getFieldWithDefault(msg, 2, ""),
pageSize: jspb.Message.getFieldWithDefault(msg, 3, 0),
count: jspb.Message.getFieldWithDefault(msg, 4, 0),
lastSyncedAt: (f = msg.getLastSyncedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.sentimentanalyzer.GetBrokersSymbolSentimentReply}
 */
proto.sentimentanalyzer.GetBrokersSymbolSentimentReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.sentimentanalyzer.GetBrokersSymbolSentimentReply;
  return proto.sentimentanalyzer.GetBrokersSymbolSentimentReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.sentimentanalyzer.GetBrokersSymbolSentimentReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.sentimentanalyzer.GetBrokersSymbolSentimentReply}
 */
proto.sentimentanalyzer.GetBrokersSymbolSentimentReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.sentimentanalyzer.BrokerSymbolInfo;
      reader.readMessage(value,proto.sentimentanalyzer.BrokerSymbolInfo.deserializeBinaryFromReader);
      msg.addBrokerSymbolInfos(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setNextPageCursor(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setPageSize(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCount(value);
      break;
    case 5:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setLastSyncedAt(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.sentimentanalyzer.GetBrokersSymbolSentimentReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.sentimentanalyzer.GetBrokersSymbolSentimentReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.sentimentanalyzer.GetBrokersSymbolSentimentReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.sentimentanalyzer.GetBrokersSymbolSentimentReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBrokerSymbolInfosList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.sentimentanalyzer.BrokerSymbolInfo.serializeBinaryToWriter
    );
  }
  f = message.getNextPageCursor();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getPageSize();
  if (f !== 0) {
    writer.writeUint32(
      3,
      f
    );
  }
  f = message.getCount();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
  f = message.getLastSyncedAt();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
};


/**
 * repeated BrokerSymbolInfo broker_symbol_infos = 1;
 * @return {!Array<!proto.sentimentanalyzer.BrokerSymbolInfo>}
 */
proto.sentimentanalyzer.GetBrokersSymbolSentimentReply.prototype.getBrokerSymbolInfosList = function() {
  return /** @type{!Array<!proto.sentimentanalyzer.BrokerSymbolInfo>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.sentimentanalyzer.BrokerSymbolInfo, 1));
};


/**
 * @param {!Array<!proto.sentimentanalyzer.BrokerSymbolInfo>} value
 * @return {!proto.sentimentanalyzer.GetBrokersSymbolSentimentReply} returns this
*/
proto.sentimentanalyzer.GetBrokersSymbolSentimentReply.prototype.setBrokerSymbolInfosList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.sentimentanalyzer.BrokerSymbolInfo=} opt_value
 * @param {number=} opt_index
 * @return {!proto.sentimentanalyzer.BrokerSymbolInfo}
 */
proto.sentimentanalyzer.GetBrokersSymbolSentimentReply.prototype.addBrokerSymbolInfos = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.sentimentanalyzer.BrokerSymbolInfo, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.sentimentanalyzer.GetBrokersSymbolSentimentReply} returns this
 */
proto.sentimentanalyzer.GetBrokersSymbolSentimentReply.prototype.clearBrokerSymbolInfosList = function() {
  return this.setBrokerSymbolInfosList([]);
};


/**
 * optional string next_page_cursor = 2;
 * @return {string}
 */
proto.sentimentanalyzer.GetBrokersSymbolSentimentReply.prototype.getNextPageCursor = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.sentimentanalyzer.GetBrokersSymbolSentimentReply} returns this
 */
proto.sentimentanalyzer.GetBrokersSymbolSentimentReply.prototype.setNextPageCursor = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional uint32 page_size = 3;
 * @return {number}
 */
proto.sentimentanalyzer.GetBrokersSymbolSentimentReply.prototype.getPageSize = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.sentimentanalyzer.GetBrokersSymbolSentimentReply} returns this
 */
proto.sentimentanalyzer.GetBrokersSymbolSentimentReply.prototype.setPageSize = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int64 count = 4;
 * @return {number}
 */
proto.sentimentanalyzer.GetBrokersSymbolSentimentReply.prototype.getCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.sentimentanalyzer.GetBrokersSymbolSentimentReply} returns this
 */
proto.sentimentanalyzer.GetBrokersSymbolSentimentReply.prototype.setCount = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional google.protobuf.Timestamp last_synced_at = 5;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.sentimentanalyzer.GetBrokersSymbolSentimentReply.prototype.getLastSyncedAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 5));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.sentimentanalyzer.GetBrokersSymbolSentimentReply} returns this
*/
proto.sentimentanalyzer.GetBrokersSymbolSentimentReply.prototype.setLastSyncedAt = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.sentimentanalyzer.GetBrokersSymbolSentimentReply} returns this
 */
proto.sentimentanalyzer.GetBrokersSymbolSentimentReply.prototype.clearLastSyncedAt = function() {
  return this.setLastSyncedAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.sentimentanalyzer.GetBrokersSymbolSentimentReply.prototype.hasLastSyncedAt = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * @enum {number}
 */
proto.sentimentanalyzer.SYMBOLS_FILTER = {
  POPULARITY: 0,
  ALPHABETICAL: 1
};

/**
 * @enum {number}
 */
proto.sentimentanalyzer.SENTIMENT_TREND = {
  UNKNOWN: 0,
  BULLISH: 1,
  BEARISH: 2
};

goog.object.extend(exports, proto.sentimentanalyzer);
